import { Action } from 'redux';

import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';

import { AcknowledgeUserIdentityConflict, ReevaluateUserIdentityConflict, ResolveAmbiguousUserIdentityConflict, RetryUserIdentityMigration } from '../../bootstrap/redux/actions/AppActionTypes';


export interface RetryUserIdentityMigrationAction extends Action {
  conflicts: IUserIdentityConflictInfo[];
}

export function retryUserIdentityMigration(conflicts: IUserIdentityConflictInfo[]): RetryUserIdentityMigrationAction {
  return {
    type: RetryUserIdentityMigration,
    conflicts
  };
}

export interface AcknowledgeUserIdentityConflictAction extends Action {
  conflicts: IUserIdentityConflictInfo[];
}

export function acknowledgeUserIdentityConflict(conflicts: IUserIdentityConflictInfo[]): AcknowledgeUserIdentityConflictAction {
  return {
    type: AcknowledgeUserIdentityConflict,
    conflicts
  };
}

export interface ReevaluateUserIdentityConflictAction extends Action {
  conflicts: IUserIdentityConflictInfo[];
}

export function reevaluateUserIdentityConflict(conflicts: IUserIdentityConflictInfo[]): ReevaluateUserIdentityConflictAction {
  return {
    type: ReevaluateUserIdentityConflict,
    conflicts
  };
}

export interface ResolveAmbiguousUserIdentityConflictAction extends Action {
  conflict: IUserIdentityConflictInfo;
}

export function resolveAmbiguousUserIdentityConflict(conflict: IUserIdentityConflictInfo): ResolveAmbiguousUserIdentityConflictAction {
  return {
    type: ResolveAmbiguousUserIdentityConflict,
    conflict
  };
}